<template>
  <div class="mySlider">
    <owl-carousel msg="This is owl carousel page"
      :data="data"
      :items="items"
      :margin="margin"
      :loop="loop"
      :autoplay="autoplay"
      :nav="nav"
      :navText="navText"
    />
  </div>
</template>

<script>

export default {
  name: 'mySlider',
  data () {
    return {
      data     : [
        {
          img : "https://cdn.shopify.com/s/files/1/0091/3775/0116/files/1.jpg?v=1545196707",
          content : {
            title    : "THE WINTER",
            subTitle : "SPORT WINTER",
            para     : "This is Photoshops version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.               Aenean sollicitudin, lorem quis",
            tag      :  "SHOP NOW"
          }
        },
        {
          img : "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
          content : {
            title    : "THE PLANET",
            subTitle : "PLANET ELEMENT",
            para     : "This is Photoshops version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.               Aenean sollicitudin, lorem quis",
            tag      :  "DETAILS"
          }
        },
        {
          img : "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
          content : {
            title    : "THE SKY",
            subTitle : "SUPER SKY",
            para     : "This is Photoshops version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.               Aenean sollicitudin, lorem quis",
            tag      :  "DETAILS"
          }
        }

      ],
      items    : 1,
      margin   : 15,
      loop     : true,
      autoplay : true,
      nav      : true,
      navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"]
    }
  }
}
</script>
